const API_KEY = '&APIKey=65d5a3e79fcd603b3845f0dc7c2437f0';

const ODDS_API_WEB = 'https://www.odds.com.au/api/web';
const PUNTERS_API_WEB_PUBLIC = 'https://www.punters.com.au/api/web/public';
const PUNT_API = 'https://puntapi.com';

const API_END_POINTS = {
  MAIN: `${ODDS_API_WEB}/Event/getEventHeader/?eventId=648428&allowGet=true${API_KEY}`,
  MENU_LIST: `${ODDS_API_WEB}/Menu/getOddsNavigationCacheable/?itemLimit=5&allowGet=true${API_KEY}`,
  SITE_MAP_MAIN: `${ODDS_API_WEB}/Sitemap/getMainSitemapSlugs/?${API_KEY}`,
  SITE_MAP_MEETINGS: `${ODDS_API_WEB}/Sitemap/getRaceMeetingSlugs/?${API_KEY}`,
  SITE_MAP_SPORT_EVENTS: `${ODDS_API_WEB}/Sitemap/getSportEventSlugs/?${API_KEY}`,
  BOOKIE_STRIP: `${ODDS_API_WEB}/Betting/getMainTile/?allowGet=true${API_KEY}`,
  NEWS_ARTICLE_CONTENT: `${PUNT_API}/news/web-odds/article/my-new-article-2017-11-30`,
  NEXT_TO_JUMP: {
    MULTIPLE_SPORTS: `${PUNTERS_API_WEB_PUBLIC}/NextToJump/getMultipleSportsCacheable/?filter=racing&allowGet=true${API_KEY}`,
    RELATED_EVENTS: `${PUNTERS_API_WEB_PUBLIC}/NextToJump/getRelatedToEvent/?eventId=666254&limit=8&allowGet=true${API_KEY}`,
  },
  NEXT_TO_PLAY: {
    MULTIPLE_SPORTS: `${PUNTERS_API_WEB_PUBLIC}/NextToJump/getMultipleSportsCacheable/?filter=sport&allowGet=true${API_KEY}`,
    RELATED_EVENTS: `${PUNTERS_API_WEB_PUBLIC}/NextToJump/getRelatedToEventCacheable/?allowGet=true${API_KEY}`,
  },
  TIPS: `${ODDS_API_WEB}/Featured/getUpcomingExpertTipsCacheable/?allowGet=true${API_KEY}`,
  ODDS_COMPARISON_TABLE: {
    BY_MEETING_SLUG: `${ODDS_API_WEB}/Meetings/getEventOddsComparisonsCacheable/?allowGet=true${API_KEY}`,
    BY_EVENT_ID: `${PUNTERS_API_WEB_PUBLIC}/Odds/getOddsComparisonCacheable/?allowGet=true${API_KEY}`,
  },
  RELATED_NEWS: `${PUNT_API}/news/web-odds/articles`,
  UPCOMING_MEETINGS: {
    BY_SPORT: `${ODDS_API_WEB}/Meetings/getUpcomingBySportCacheable/?allowGet=true${API_KEY}`,
    BY_REGION: `${ODDS_API_WEB}/Meetings/getUpcomingByRegionCacheable/?allowGet=true${API_KEY}`,
  },
  MEETING: {
    BY_SLUG: `${ODDS_API_WEB}/Meetings/getMeetingBySlugCacheable/?allowGet=true${API_KEY}`,
  },
  VERDICT: `${ODDS_API_WEB}/Verdict/getForMeetingCacheable/?allowGet=true${API_KEY}`,
  BLOB: `${ODDS_API_WEB}/Blobs/getBlobByPathCacheable/?allowGet=true${API_KEY}`,
  MARKET_SPECIALS: `${ODDS_API_WEB}/Promotions/getUpcomingGroupedByMeetingCacheable/?allowGet=true${API_KEY}`,
  ODDS: {
    EVENT: `${PUNT_API}/odds/event/`,
    EVENTS: `${PUNT_API}/odds/events/`,
  },
  CONTACT_US: `${PUNTERS_API_WEB_PUBLIC}/Contact/sendUserFeedbackToService/?allowGet=true${API_KEY}`,
  LIVE_SCORES: `${PUNT_API}/livescores/getScore/`,
  PRODUCT_INTEGRATION: `${ODDS_API_WEB}/Odds/getMeetingHeader/?allowGet=true${API_KEY}`,
  UP_COMING_RACES: `${ODDS_API_WEB}/public/Racing/getUpcomingRacesByMeetingSlugCacheable/?allowGet=true${API_KEY}`,
  EXPERT_TIPS: `${PUNTERS_API_WEB_PUBLIC}/ExpertTips/getExpertTipsCacheable/?allowGet=true${API_KEY}`,
  FORM_FINDER: `${PUNT_API}/stats/sport/horse-racing/filter/upcoming`,
  FORM_FINDER_FIELDS: `${PUNT_API}/stats/filter-fields/form-finder`,
  GEAR_CHANGES: `${PUNTERS_API_WEB_PUBLIC}/Meetings/getUpcomingGearChangesCacheable/?allowGet=true${API_KEY}`,
};

export default API_END_POINTS;
